jQuery(function($) {

    $('.choice-container > label').each(function() {

        $(this).on('touchstart click', function(e){
            e.preventDefault();
            if($(this).find('input').is(':checked')){
                $(this).find('input').prop('checked', false);
            } else {
                $(this).find('input').prop('checked', true);
            }
            $(this).closest('form').submit();
        });
    });

});